import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import HomePage from 'Pages/HomePage';
import AboutUs from 'Pages/AboutUs';
import Solutions from 'Pages/Solutions';
import ContactUs from 'Pages/ContactUs';
import ScrollToTop from 'Components/ScrollToTop';

export default function App() {
  return (
    <div>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route
            // @ts-ignore
            exact
            path="/"
            element={<HomePage />}
          />
          <Route
            // @ts-ignore
            exact
            path="/about-us"
            element={<AboutUs />}
          />
          <Route
            // @ts-ignore
            exact
            path="/solution"
            element={<Solutions />}
          />
          <Route
            // @ts-ignore
            exact
            path="/contact-us"
            element={<ContactUs />}
          />
        </Routes>
      </Router>
    </div>
  );
}
